export default {
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_EYE_LABEL: 'OJO',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_POWER_LABEL: 'POWER',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_DIA_LABEL: 'DIA',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_BC_LABEL: 'BC',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_ADD_LABEL: 'ADD',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_BOXES_LABEL: 'CAJAS',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_AXIS_LABEL: 'AXIS',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_CYL_LABEL: 'CYL',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_COLOR_LABEL: 'COLOR',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_EYE_TYPE_RIGHT_LONG_LABEL:
        'OD (Ojo derecho)',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_EYE_TYPE_LEFT_LONG_LABEL:
        'OS (Ojo izquierdo)',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_EYE_TYPE_RIGHT_LABEL: 'OD (derecho)',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_EYE_TYPE_LEFT_LABEL: 'OS (izquierdo)',
    ADD_PRESCRIPTION_STEP_1_LEFT: 'OS (Ojo izquierdo)',
    CONTACT_LENSES_SHOW_SAVED_PRESCRIPTION: 'Mostrar receta',
    CONTACT_LENSES_PRESCRIPTION_INFO_LOGGED:
        'Don’t forget to save this prescription at checkout for future speedier shopping!',
    CONTACT_LENSES_PRESCRIPTION_INFO_GUEST_PT1: 'Insert your prescription values below or',
    CONTACT_LENSES_PRESCRIPTION_INFO_GUEST_PT2: 'to select one of your saved prescriptions.',
    CONTACT_LENSES_PRESCRIPTION_INCLUDE_PRODUCT_IN_PURCHASE_CHECKBOX:
        'Include this product in my purchase',
    MYPROFILE_MY_PRESCRIPTIONS_TILE_UPLOAD: 'Cargado a',
    MYPROFILE_MY_PRESCRIPTIONS_TILE_UPDATE: 'Última actualización: ',
    MYPROFILE_MY_PRESCRIPTIONS_TILE_JUST_UPDATED: 'Recién actualizado',
    MYPROFILE_MY_PRESCRIPTIONS_TILE_TODAY: 'Hoy',
    MYPROFILE_MY_PRESCRIPTIONS_TILE_YESTERDAY: 'Ayer',
    SIGN_IN: 'sign in',
    MYPROFILE_NO_PRESCRIPTION_SAVED_PT1:
        "You don't have a prescription saved in your account including this product.",
    MYPROFILE_NO_PRESCRIPTION_SAVED_PT2:
        'Agregue su receta a continuación y guárdela para futuras compras.',
    CL_PDP_TITLE: 'Seleccione su receta',
    CL_PDP_ERROR:
        'Seleccione su graduación para añadir lentes de contacto al carrito y quite la marca en la casilla si solo los necesita para un solo ojo.',
    CL_PDP_PRESCRIPTION_NOT_AVAIABLE: 'La graduación que seleccionó no está disponible',
    YOUR_PRESCRIPTION_TITLE: 'Su receta',
    YOUR_PRESCRIPTION_SUBTITLE_PT1:
        'Usaremos esta información para asegurarnos de que su pedido sea correcto.',
    YOUR_PRESCRIPTION_SUBTITLE_PT2: '¡Tenemos lo que necesita!',
    YOUR_DOCTOR_DETAILS: 'Información de su doctor',
    DOCTOR_NAME: 'nombre del doctor',
    CLINIC_NAME: 'nombre de la clínica',
    ADDRESS: 'Dirección ',
    SUBMISSION_METHOD: 'Su método de envío',
    MY_SAVED_PRESCRIPTION_TITLE_LABEL: 'My saved prescriptions',
    MY_SAVED_PRESCRIPTION_PRESCRIPTION_NAME_LABEL: 'Nombre de la receta',
    SAME_PRESCRIPTION_BOTH_EYES: 'Same prescription for both eyes',
    ADD_NEW_PRESCRIPTION_DISCOUNT_LABEL_1: 'Ahorre ',
    ADD_NEW_PRESCRIPTION_DISCOUNT_LABEL_2: ' cuando compre su suministro anual de ',
    ADD_NEW_PRESCRIPTION_DISCOUNT_LABEL_3: ' cajas.',
    ADD_NEW_PRESCRIPTION_DISCOUNT_6_MONTHS_LABEL_2: ' cuando compre un suministro para 6 meses de ',
};
